import { CardContent, CardHeader, Stack } from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import Table from "../../../components/Table";
import { useEffect, useState } from "react";
import { FileUpload, FilterAlt } from "@mui/icons-material";
import { deleteData, fetchData } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";
import BulkUpload from "../../../components/blukUplod";
import InsurerCityFilterDialog from './components/InsurerCityFilterDialog.js';

const InsurerCityList = () => {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const currentPage = useSelector(
    (state) => state?.insurerCityStore?.currentPage
  );
  const rowsPerPage = useSelector(
    (state) => state?.insurerCityStore?.rowsPerPage
  );
  const totalPages = useSelector(
    (state) => state?.insurerCityStore?.totalPages
  );

  const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [search, setSearch] = useState("");
  const [CityData, setCityData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [filterData, setFilterData] = useState({
    isActive: "",
    gInsurerId: "",
  });

  useEffect(() => {
    fetchCityList();
  }, [isRefresh, currentPage, rowsPerPage,search]);

  //List API
  const fetchCityList = async () => {
    setCircleLoading(true)
    try {

      let url = `/reference/insurer/city?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}&gInsurerId=${filterData?.gInsurerId}`;
                                    
      //for active and inactive status
      if(filterData.isActive !== "") {
        url += `&isActive=${filterData.isActive}`;
      }
  
      const response = await fetchData(url);
      if (response?.success) {
        setCityData(response?.data?.items);
        dispatch(setTotalPages(response?.data?.totalPages));
      } else {
        //throw error
        showSnackbar("Error Fetching City List", "error");
      }
    } catch (error) {
      showSnackbar(error?.response?.data?.message || 'Network Error', "error");
    } finally {
      setCircleLoading(false);
    }
  };

  const handleDelete = async (row) => {
    setCircleLoading(true);
    try {
      const response = await deleteData(`/reference/insurer/city-delete`, {
        ids: [row?.id],
      });
      const responseMessage = response?.message;
      setIsRefresh(!isRefresh);
      if (response?.success) {
        showSnackbar(responseMessage, "success");
      } else {
        showSnackbar(responseMessage, "success");
      }
    } catch (error) {
      showSnackbar(error?.response?.data?.message || 'Network Error', "error");
    } finally {
      setCircleLoading(false);
    }
  };

  //Table Mapping
  const districtListTable = {
    columns: [
      {
        key: "sno",
        label: "S.No.",
        renderCell: (row) => row.sno,
      },     
      {
        key: "name",
        label: "City Name",
        renderCell: (row) => row.name,
      },
      {
        key: "code",
        label: "Code",
        renderCell: (row) => row.code,
      },
      {
        key: "district",
        label: "Disctrict",
        renderCell: (row) => row.district,
      },
      {
        key: "createdAt",
        label: "Created At",
        renderCell: (row) => row.createdAt,
      },
      {
        key: "isActive",
        label: "Status",
        renderCell: (row) => (
          <span>
            {row.isActive ? (
              <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
            ) : (
              <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
            )}
          </span>
        ),
      },
    ],
    rows: CityData?.map((City, index) => ({
      id: City?.id,
      sno: index + 1,
      name: City?.name || "",
      code: City?.code || "",
      district: City?.district?.name || "",
      isActive: City?.isActive,
      createdAt: new Date(City?.createdAt).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
    })),
  };

  const handleAddNewCity = () => {
    navigate(`/insurer-master/insurer-city/add-city`);
  };

  const actions = {
    edit: true,
    view: true,
    delete: true,

    onEdit: (row) => {
      navigate(
        `/insurer-master/insurer-city/add-city?pageType=edit&id=${row.id}`
      );
    },
    onView: (row) => {
      navigate(
        `/insurer-master/insurer-city/add-city?pageType=view&id=${row.id}`
      );
    },
    onDelete: (row) => handleDelete(row),
  };

  const handlePaginationChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    dispatch(setRowsPerPage(rowsPerPage));
    dispatch(setCurrentPage(1));
  };

  const handleSearch = (value) => {
    setSearch(value);
  };
  return (
    <DashboardLayout>
      <CardHeader
        title={
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Insurer City List
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                List of City around the world linked to Insurers.
              </MaterialTypography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <MaterialButton
              variant="gradient"
              color="dark"
              size="small"
              startIcon={<FilterAlt/>}
              onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                Filter
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FileUpload />}
                onClick={() => setOpenUploadFileDialog(true)}
              >
                Bulk Upload
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddNewCity()}
              >
                City
              </MaterialButton>
            </Stack>
          </Stack>
        }
      />
      <CardContent>
        <Table
          columns={districtListTable?.columns}
          data={districtListTable?.rows}
          actions={actions}
          pagination={{
            totalPages,
            currentPage,
            onPageChange: (page) => handlePaginationChange(page),
            rowsPerPage,
            onRowsPerPageChange: (rowsPerPage) =>
              handleRowsPerPageChange(rowsPerPage),
            rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel="No Insurer City found"
          handleSearch={handleSearch}
        />
      </CardContent>
      <BulkUpload
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        endPoint="/motor/insurer/bulkUpload/insurer-city"
        fetchList={fetchCityList}
      />
      <InsurerCityFilterDialog
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
      filterData={filterData}
      setFilterData={setFilterData}
      onApply={() => {
        setAnchorEl(null);   // close popup
        fetchCityList();  // call API after filter applied
      }}
      />
    </DashboardLayout>
  );
};

export default InsurerCityList;
